import { createAction, props } from '@ngrx/store';
import { ContactApiModel } from 'app/models/contact-api.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { MwLoadOptions } from 'app/models/load-options.model';

export const loadContacts = createAction(
  '[Contacts] Load',
  props<{ loadOptions?: MwLoadOptions }>()
);

export const loadContactsSuccess = createAction(
  '[Contacts] Load Successful',
  props<{ response: MwPayloadModel<ContactApiModel[]> | ContactApiModel[] }>()
);

export const loadContactsFailed = createAction(
  '[Contacts] Load Failed',
  props<{ error: any }>()
);

export const createContact = createAction(
  '[Contacts] Create',
  props<{ contact: ContactApiModel }>()
);

export const createContactSuccess = createAction(
  '[Contacts] Create Successful',
  props<{ contact: ContactApiModel }>()
);

export const createContactFailed = createAction(
  '[Contacts] Create Failed',
  props<{ error: any }>()
);

export const updateContact = createAction(
  '[Contacts] Update',
  props<{ contact: ContactApiModel }>()
);

export const updateContactSuccess = createAction(
  '[Contacts] Update Successful'
);

export const updateContactFailed = createAction(
  '[Contacts] Update Failed',
  props<{ error: any }>()
);

export const deleteContact = createAction(
  '[Contacts] Delete',
  props<{ contact: ContactApiModel[] }>()
);

export const deleteContactSuccess = createAction(
  '[Contacts] Delete Successful'
);

export const deleteContactFailed = createAction(
  '[Contacts] Delete Failed',
  props<{ error: any }>()
);

export const resetContacts = createAction('[Contacts] Reset');
